// import { CognitoUser } from 'amazon-cognito-identity-js';
// import { Amplify, Auth } from 'aws-amplify';
// import config from "../config.json";
// import { UserData } from '@mikros/library';

// export default class AuthService {

//     private cognitoUser: CognitoUser = {} as CognitoUser;

//     static classInstance: AuthService;
//     static getInstance() {
//         if (!AuthService.classInstance) {
//             AuthService.classInstance = new AuthService();
//         }
//         return this.classInstance;
//     }

//     constructor() {
//         Amplify.configure(config.amplify.Auth);
//     }

//     async signIn(mobileNumber: string) {
//         this.cognitoUser = await Auth.signIn(mobileNumber);
//     }

//     async answerCustomChallenge(answer: string) {
//         this.cognitoUser = await Auth.sendCustomChallengeAnswer(this.cognitoUser, answer);
//         return this.isAuthenticated();
//     }

//     async isAuthenticated() {
//         try {
//             await Auth.currentSession();
//             return true;
//         } catch {
//             return false;
//         }
//     }

//     async getUserDetails() {
//         if (!this.cognitoUser) {
//             this.cognitoUser = await Auth.currentAuthenticatedUser();
//         }
//         return await Auth.userAttributes(this.cognitoUser);
//     }

//     async signOut() {
//         await Auth.signOut({ global: true });
//         localStorage.clear();
//     }

//     getTokens() {
//         return Auth.currentSession().then((res: any) => {
//             let accessToken = res.getAccessToken();
//             let idToken = res.getIdToken();
//             let refreshToken = res.getRefreshToken();

//             return { accessToken: accessToken.getJwtToken(), idToken: idToken.getJwtToken(), refreshToken: refreshToken.getToken() };
//         })
//     }

//     getIdToken() {
//         return Auth.currentSession().then((res: any) => {
//             return res.getIdToken().getJwtToken();
//         })
//     }

//     async signUp(userData: UserData) {
//         const { user } = await Auth.signUp({
//             username: userData.phone,
//             password: userData.password,
//             attributes: {
//                 email: userData.email,
//                 phone_number: userData.phone,
//                 name: userData.firstName + " " + userData.lastName,
//                 given_name: userData.firstName,
//                 family_name: userData.lastName,
//                 birthdate: userData.birthDate,
//                 gender: userData.gender
//             }
//         });
//         return user;
//     }

//     async confirmSignUp(username: string, code: string) {
//         return await Auth.confirmSignUp(username, code);
//     }

//     async resendSignUp(username: string) {
//         return await Auth.resendSignUp(username);
//     }
// }


import {
    signIn,
    signOut,
    // sendCustomChallengeAnswer,
    fetchAuthSession,
    getCurrentUser,
    confirmSignUp,
    resendSignUpCode,
    signUp,
    fetchUserAttributes,
    // getUserAttributes,
  } from "aws-amplify/auth";
  import { confirmSignIn } from "aws-amplify/auth";
  import { CognitoUser } from "amazon-cognito-identity-js";
  import { UserData } from "@mikros/library";
  
  export default class AuthService {
    private cognitoUser: CognitoUser = {} as CognitoUser;
  
    static classInstance: AuthService;
    static getInstance() {
      if (!AuthService.classInstance) {
        AuthService.classInstance = new AuthService();
      }
      return this.classInstance;
    }
  
    // async signIn(mobileNumber: string) {
    //   this.cognitoUser = await signIn({ username: mobileNumber });
    // }
    async signIn(mobileNumber: string) {
        return await signIn({ username: mobileNumber });
      }
  
    // async answerCustomChallenge(answer: string) {
    //   this.cognitoUser = await sendCustomChallengeAnswer({
    //     user: this.cognitoUser,
    //     challengeResponse: answer,
    //   });
    //   return this.isAuthenticated();
    // }


// async answerCustomChallenge(answer: string) {
//     this.cognitoUser = await confirmSignIn({ challengeResponse: answer });
//     return this.isAuthenticated();
//   }

  async answerCustomChallenge(answer: string) {
    return await confirmSignIn({ challengeResponse: answer });
  }
  
    async isAuthenticated() {
      try {
        await fetchAuthSession();
        return true;
      } catch {
        return false;
      }
    }
  
    async getUserDetails() {
    //   if (!this.cognitoUser) {
    //     this.cognitoUser = await getCurrentUser();
    //   }
    //   return await fetchUserAttributes({ user: this.cognitoUser });
      return await fetchUserAttributes();
    }
  
    async signOut() {
      await signOut({ global: true });
      localStorage.clear();
    }
  
    // async getTokens() {
    //   const session = await fetchAuthSession();
    //   return {
    //     accessToken: session.tokens?.accessToken?.toString() ?? "",
    //     idToken: session.tokens?.idToken?.toString() ?? "",
    //     refreshToken: session.tokens?.refreshToken?.toString() ?? "",
    //   };
    // }
    async getTokens() {
        const session = await fetchAuthSession();
        return {
          accessToken: session.tokens?.accessToken?.toString() ?? "",
          idToken: session.tokens?.idToken?.toString() ?? "",
          // refreshToken: Not available in Amplify v6+
        };
      }
  
    async getIdToken() {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() ?? "";
    }
  
    // async signUp(userData: UserData) {
    //   const { user } = await signUp({
    //     username: userData.phone,
    //     password: userData.password,
    //     options: {
    //       userAttributes: {
    //         email: userData.email,
    //         phone_number: userData.phone,
    //         name: `${userData.firstName} ${userData.lastName}`,
    //         given_name: userData.firstName,
    //         family_name: userData.lastName,
    //         birthdate: userData.birthDate,
    //         gender: userData.gender,
    //       },
    //     },
    //   });
    //   return user;
    // }
    async signUp(userData: UserData) {
        const { isSignUpComplete, nextStep, userId } = await signUp({
          username: userData.phone,
          password: userData.password,
          options: {
            userAttributes: {
              email: userData.email,
              phone_number: userData.phone,
              name: `${userData.firstName} ${userData.lastName}`,
              given_name: userData.firstName,
              family_name: userData.lastName,
              birthdate: userData.birthDate,
              gender: userData.gender,
            },
          },
        });
      
        return { isSignUpComplete, nextStep, userId };
      }
      
    async confirmSignUp(username: string, code: string) {
      return await confirmSignUp({ username, confirmationCode: code });
    }
  
    async resendSignUp(username: string) {
      return await resendSignUpCode({ username });
    }
  }